/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'round-arrow': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M30.8 16c0-8.174-6.626-14.8-14.8-14.8S1.2 7.826 1.2 16 7.826 30.8 16 30.8 30.8 24.174 30.8 16zm-14.203-5.614c.01.002.019.006.028.009a.496.496 0 01.227.127l4.624 4.623a.501.501 0 01-.707.708l-3.77-3.77v8.04a.5.5 0 01-1 0V12.08l-3.77 3.771a.501.501 0 01-.707-.707l4.623-4.623a.496.496 0 01.227-.127l.028-.01a.507.507 0 01.197 0zm15.398 6.027c-.216 8.509-7.073 15.366-15.582 15.582L16 32C7.163 32 0 24.837 0 16l.005-.413C.224 6.94 7.302 0 16 0l.413.005C25.06.224 32 7.302 32 16l-.005.413z" _fill="#0077C8"/>'
  }
})
